<template>
  <div class="container">
    <van-nav-bar class="header" :fixed="true" :title="lang.selectWords" left-arrow @click-left="onClickLeft" />

    <div class="middle">
      <h3>{{ lang.usualWords }}</h3>
      <span class="font" v-if="$route.query.id==='title'">{{ lang.maxSentence }}</span>
      <span class="font" v-else>{{ lang.maxInSentence }}</span>
      <div class="word-title">{{ lang.commonVocabulary }}</div>
      <div class="content">
        <ul v-if="words">
          <li v-for="(item, index) in words" :key="index" :class="{ selected: chooseAfterValue.indexOf(item) != -1 }" @click="change(index, item)">{{ item.chinese }}</li>
        </ul>
      </div>
      <div class="word-title">{{ lang.communcialBuildingExclusiveVocabulary }}</div>
      <div class="content">
        <ul v-if="words">
          <li v-for="(item, index) in businessWords" :key="index" :class="{ selected: chooseAfterValue.indexOf(item) != -1 }" @click="change(index, item)">{{ item.chinese }}</li>
        </ul>
      </div>
    </div>

    <div class="footer">
      <van-button type="default" class="button" @click="cancel">{{ lang.clearAll }}</van-button>
      <van-button type="danger" class="button" @click="submitwords">{{ lang.confirm }}</van-button>
    </div>
  </div>
</template>

<script>
import lang from './../../../common/language/post';
import { Dialog } from 'vant';
export default {
  name: 'words',
  data() {
    return {
      propertyCategory: '',
      language: document.URL.indexOf('en-us') > -1 ? 'en-us' : document.URL.indexOf('zh-cn') > -1 ? 'zh-cn' : 'zh-hk',
      lang,
      words: [],
      businessWords: [],
      chooseAfterValue: [],
      historyValue:[],
      history:[],
      cnWords: [],
      enWords: [],
    };
  },
  methods: {
    //提交选项中的文字,应该判断是从哪里点进来的哪一个button
    submitwords() {
      let newCnArray = [];
      let newEnArray = [];
      let ChiWords=''
      let EngWords=''
      newCnArray = this.chooseAfterValue.map((item) => {
        ChiWords =item.chinese+" "
        return  ChiWords;
        // return item.chinese
      });
      newEnArray = this.chooseAfterValue.map((item) => {
        EngWords=item.english+" "
        return EngWords
        // return item.english
      });
      this.cnWords = newCnArray;
      this.enWords = newEnArray;
      if (this.$route.query.id === 'title') {
        console.log(this.enWords);
        this.store.commit('setWordsList', this.cnWords);
        this.store.commit('setenWordsList', this.enWords);
      } else {
        this.store.commit('setIntroduce', this.cnWords);
        this.store.commit('setenIntroduce', this.enWords);
      }
      window.stop();
      this.$router.go(-1);
      // this.$router.push('/post');
    },

    //清空选中
    cancel() {
      this.chooseAfterValue = [];
    },
    change(n, value) {
      if (this.chooseAfterValue.indexOf(value) != -1) {
        this.chooseAfterValue.splice(this.chooseAfterValue.indexOf(value), 1);
      } else {
        if (this.$route.query.id === 'title'&& this.chooseAfterValue.length >= 5 || this.$route.query.id === 'introduce'&& this.chooseAfterValue.length >= 10) {
          return false;
        } else {
          this.chooseAfterValue.push(value);
        }
      }
    },
    onClickLeft() {
      this.store.commit('setRentalType', false)
      this.$router.go(-1);
    },
  },
  mounted: function () {
    this.propertyCategory = this.$route.query.propertyCategory;
    this.axios
      .get(this.pub.getApi().GetCommonWord)
      .then((res) => {
        let arr = [];
        let array = [];
        const { data, status } = res;
        if (status == 200) {
          arr = data.result.words;
          // 过滤出名字;'
          arr.forEach((item, index) => {
            array.push(item);
          });
        }
        // words关键字数组中对象去重
        var hash = {};
        var finalarr = [];
        finalarr = array.reduce(function (item, next) {
          hash[next.chinese] ? '' : (hash[next.chinese] = true && item.push(next));
          return item;
        }, []);
        console.log(finalarr);
        this.words = finalarr;

        // function unique(arr) {
        //   if (!Array.isArray(arr)) {
        //     console.log('type error!');
        //     return;
        //   }
        //   var array = [];
        //   for (var i = 0; i < arr.length; i++) {
        //     if (!array.includes(arr[i])) {
        //       array.push(arr[i]);
        //     }
        //   }
        //   return array;
        // }
        // this.words = unique(array);
      })
      .catch(function (error) {
        console.log(error);
      });
      this.axios
      .get(this.pub.getApi().GetBusinessCommonWord)
      .then((res) => {
        let arr = [];
        let array = [];
        const { data, status } = res;
        if (status == 200) {
          arr = data.result.words;
          // 过滤出名字;'
          arr.forEach((item, index) => {
            array.push(item);
          });
        }
        // words关键字数组中对象去重
        var hash = {};
        var finalarr = [];
        finalarr = array.reduce(function (item, next) {
          hash[next.chinese] ? '' : (hash[next.chinese] = true && item.push(next));
          return item;
        }, []);
        console.log(finalarr);
        this.businessWords = finalarr;

        // function unique(arr) {
        //   if (!Array.isArray(arr)) {
        //     console.log('type error!');
        //     return;
        //   }
        //   var array = [];
        //   for (var i = 0; i < arr.length; i++) {
        //     if (!array.includes(arr[i])) {
        //       array.push(arr[i]);
        //     }
        //   }
        //   return array;
        // }
        // this.words = unique(array);
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  components: {},
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 47px;
  background-color: #fafbfc;
  position: absolute;
  top: 0;
  left: 0;
}
.middle {
  position: absolute;
  top: 50px;
  bottom: 50px;
  left: 0;
  overflow: auto;
  padding: 19px 17px 3px 16px;
  text-align: left;
}
h3 {
  margin: 2px 0 4px 0;
  font-size: 17px;
  color: #333333;
}
.font {
  font-size: 12px;
  color: #999999;
}
ul {
  width: 100%;
  /* height: 460px; */
  margin-top: 22px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
ul li {
  width: 30%;
  height: 32px;
  opacity: 1;
  font-weight: 400;
  font-family: PingFangSC, PingFangSC-Regular;
  color: #333333;
  text-align: center;
  line-height: 32px;
  margin-bottom: 10px;
  font-size: 12px;
  display: inline-block;
  border: 1px solid #e5e8e9;
}
ul:after {
  content: '';
  width: 30%;
}
.selected {
  color: #ffffff;
  background-color: #ff0000;
}
.footer {
  width: 100%;
  height: 50px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.footer button {
  width: 50%;
  height: 50px;
  margin: 0;
  padding: 0;
}
.word-title {
  margin-top: 15px;
  font-weight: bold;
  font-size: 20px;
}
</style>
